<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  [isEmpty]="!(tableData$ | async)?.length"
  [emptyTitle]="'noTreatments' | translate"
  [emptyDescription]="'noTreatmentsInAdvice' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  [primaryActionText]="'printReport' | translate"
  (primaryAction)="print()"
  (backAction)="back()"
  [buttonItems]="buttonItems$ | async"
  (buttonAction)="buttonAction($event)"
>
  <agr-print-page
    [footerText]="
      ((isGBM$ | async) ? 'gbmWarningFooter' : 'fertilizationWarningFooter') | translate
    "
    [relatedPeople]="relatedPeople$ | async"
    [marginLeft]="true"
    [showPageNumber]="false"
  >
    <app-general-info></app-general-info>
    <div class="spacing--margin-half-vertical">
      <p class="print-only">
        {{ 'organicMatterReportInfo' | translate }}
      </p>

      <app-organic-matter-table [tableReportData$]="sortedTableData$"></app-organic-matter-table>
    </div>
  </agr-print-page>
</agr-page-detail>
